<template>
  <section class="curation-synonyms">
    <CurationHeader />   
  </section>
</template>

<script>
import CurationHeader from "@/components/curation/shared/header.vue";
//import { ChemspiderDataService } from "@/api";
export default {
  components: { CurationHeader },
  name: 'CurationSynonyms',    
};
</script>